import { WaitActionTimePeriod, WaitAmountUnit } from '../workflow-form.model';

export const SIMPLE_NOTIFICATIONS_WORK_QUEUE_NAME = 'Simple Notifications';
export const SIMPLE_NOTIFICATIONS_ALERT_EVENT_BC = 'SIMPLENOTIFICATION';

export interface SimplifiedWorkflowStepFormDataBase {
  title: string;
  type: StepType;
  tempId?: string;
  parentId?: string;
  branch?: string;
}

export interface SimplifiedWorkflowTriggerStepFormData extends SimplifiedWorkflowStepFormDataBase {
  event?: string;
  wait?: SimplifiedWorkflowWait;
}

export interface SimplifiedWorkflowActionStepFormData extends SimplifiedWorkflowStepFormDataBase {
  actionType?: ActionType;
}

export interface SendMessageActionFormData extends SimplifiedWorkflowActionStepFormData {
  messageType?: SendMessageType;
  recipient?: SendMessageRecipient;
  message?: string;
  interactiveResponse?: boolean;
  supportsInteractive?: boolean;
  responseTimeoutMinutes?: string;
  sendReminderIfNoResponse?: boolean;
  numberOfReminders?: string;
  sendReminderAfterMinutes?: string;
  alertReminder?: string;
  alertForSTOReservations?: boolean;
  sameAsInitialMessage?: boolean;
  branches?: string[];
}

export type SimplifiedWorkflowStepFormData =
  | SimplifiedWorkflowTriggerStepFormData
  | SendMessageActionFormData;

export interface SimplifiedWorkflowWait {
  waitAmount?: string;
  waitAmountUnit?: WaitAmountUnit;
  waitTimePeriod?: WaitActionTimePeriod;
}

export enum StepType {
  Trigger = 'Trigger',
  Action = 'Action',
}

export enum ActionType {
  SendMessage = 'SendMessage',
  ActivateWillCall = 'ActivateWillCall',
  CancelReturnTrip = 'CancelReturnTrip',
}

export enum SendMessageType {
  SMS = 'ALERTSMS',
  Email = 'ALERTEMAIL',
  Voice = 'ALERTVOICE',
}

export enum SendMessageRecipient {
  Member = 'ALERTPASSENGER',
  Provider = 'ALERTTP',
  Internal = 'ALERTINTERNAL',
}

export enum DateRange {
  Today = 'Today',
  Yesterday = 'Yesterday',
  ThisWeek = 'ThisWeek',
  ThisMonth = 'ThisMonth',
}
